import React, { Component } from "react";
import moment from "moment";
import cx from "classnames";
import "./Calendar.css";

export default class Calendar extends Component {
  constructor(props) {
    super(props);
    this.renderDays = this.renderDays.bind(this);
  }

  onDateSelect(date) {
    this.props.onDateSelect(date);
  }

  renderWeekDays(day, id) {
    return (
      <div className={"Calendar__DayLabel"} key={id}>
        {day}
      </div>
    );
  }

  renderDays(day, id, workedDays, approved) {
    const { date } = this.props;
    const currentDate = moment().format("YYYY-MM-DD HH:mm");

    const dayDate = moment(date)
      .startOf("month")
      .add(day - 1, "days")
      .format("YYYY-MM-DD HH:mm");
    const weekend =
      moment(date)
        .startOf("month")
        .add(day - 1, "days")
        .format("dd")[0] === "S";
    const isDate = moment(date).format("D") === String(day);
    const isToday =
      moment(currentDate).format("D") === String(day) &&
      moment(date).format("YYYY-MM") === moment(currentDate).format("YYYY-MM");
    const isInPast =
      moment(moment(date).format("YYYY-MM")).isBefore(
        moment(currentDate).format("YYYY-MM")
      ) ||
      (moment(currentDate).format("DD") > day &&
        moment(date).format("YYYY-MM") ===
          moment(currentDate).format("YYYY-MM"));

    const requiredMinutes = this.props.requiredMinutes;

    return (
      <div
        data-testid="calendar-day"
        className={cx("Calendar__DayIcon", {
          Calendar__DayToday: isToday,
          Calendar__Approved: approved && approved.findIndex(
            (d) =>
              moment(d.date).format("YYYY-MM-DD") ===
              moment(dayDate).format("YYYY-MM-DD")
          ) > -1,
          Calendar__DayOfWeekend: weekend,
          Calendar__SelectedDay: isDate,
          Calendar__Enough:
            workedDays[day] && workedDays[day].minutes >= requiredMinutes,
          Calendar__NotEnough:
            isInPast &&
            !weekend &&
            (!workedDays[day] || workedDays[day].minutes < requiredMinutes),
        })}
        key={id}
        onClick={this.onDateSelect.bind(this, dayDate)}
      >
        <div className="Calendar__Bubble">{day}</div>
      </div>
    );
  }

  renderEmptyDays(n, id) {
    return <div className={"Calendar__NoDayIcon"} key={id}></div>;
  }

  render() {
    const { days, date, approved } = this.props;
    const workedDays = {};
    days.forEach((fe, i) => {
      const key = moment(fe.date).utc().format("D");
      workedDays[key] = {
        date: key,
        minutes: workedDays[key]
          ? workedDays[key].minutes + fe.minutes
          : fe.minutes,
      };
    });

    const noOfDays = moment(date).daysInMonth();
    let arrayOfWeekDays = moment.weekdaysMin();
    // Start Week on Monday by moving last element to first position
    arrayOfWeekDays.push(arrayOfWeekDays.shift());
    // Pick only the first letter
    arrayOfWeekDays = arrayOfWeekDays.map((n, i) => {
      return n[0];
    });
    // Get first day of the week for this month
    const firstWeekDayofMonth = moment(date).startOf("month").weekday();

    // Empty days to be printed at the beggining of the month (Sunday is 0 instead of 7)
    const emptyDaysToAdd =
      firstWeekDayofMonth !== 0 ? firstWeekDayofMonth - 1 : 6;

    const arrayOfDays = Array.apply(null, { length: noOfDays })
      .map(Number.call, Number)
      .map((n, i) => n + 1);

    // console.log("ABC", styles.container, arrayOfWeekDays, emptyDaysToAdd);

    return (
      <div className="Calendar">
        {arrayOfWeekDays.map(this.renderWeekDays)}
        {Array(emptyDaysToAdd)
          .fill(0)
          .map((m, i) => this.renderEmptyDays(m, i))}
        {arrayOfDays.map((m, i) => this.renderDays(m, i, workedDays, approved))}
      </div>
    );
  }
}
